import { render, staticRenderFns } from "./NewNotice.vue?vue&type=template&id=f685882c&scoped=true&lang=pug&"
import script from "./NewNotice.vue?vue&type=script&lang=js&"
export * from "./NewNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f685882c",
  null
  
)

export default component.exports